import './powershellpage.scss';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import { changeToSettingMode } from '../../../js/actions/appModeActionCreators';
import AgentIcon from '../../../icons/agent.svg';
import PowerShellIcon from '../../../icons/clone-icons-powershell.svg';

const PowerShellPage = React.createClass({
    componentDidMount: function () {
        this.props.alignMode();
    },
    render: function () {
        return (
            <div className="powershell-page">
                <h1>PowerShell</h1>
                <p>Automate aspects of SQL Clone with PowerShell cmdlets.</p>
               
                <h2>Create an image</h2>
                <p>From SQL Server:</p>
                <pre className="powershell-example">
                   {`Connect-SqlClone -ServerUrl 'http://sql-clone.example.com:14145'
$sqlServerInstance = Get-SqlCloneSqlServerInstance -MachineName WIN201601 -InstanceName SQL2014
$imageDestination = Get-SqlCloneImageLocation -Path '\\\\red-gate\\data-images'

$imageOperation = New-SqlCloneImage -Name "AdventureWorks-$((get-date).ToString("yyyyMMddHHmmss"))" \`
  -SqlServerInstance $sqlServerInstance \`
  -DatabaseName 'AdventureWorks' \`
  -Destination $imageDestination

$imageOperation | Wait-SqlCloneOperation`}
                </pre>

                <p>From a backup:</p>
                <pre className="powershell-example">
                    {`Connect-SqlClone -ServerUrl 'http://sql-clone.example.com:14145'
$backupLocation = Get-SqlCloneBackupLocation -Path '\\\\red-gate\\backups'
$imageDestination = Get-SqlCloneImageLocation -Path '\\\\red-gate\\data-images'

$imageOperation = New-SqlCloneImage -Name "AdventureWorks-$((get-date).ToString("yyyyMMddHHmmss"))" \`
  -BackupLocation $backupLocation \`
  -BackupFileName @('AdventureWorks-201701012210.bak') \`
  -Destination $imageDestination

$imageOperation | Wait-SqlCloneOperation`}
                </pre>

                <hr/>

                <h2>Create a clone</h2>
                <pre className="powershell-example">
                    {`Connect-SqlClone -ServerUrl 'http://sql-clone.example.com:14145'
$image = Get-SqlCloneImage -Name 'AdventureWorks-20170106110745'
$sqlServerInstance = Get-SqlCloneSqlServerInstance -MachineName WIN201601 -InstanceName SQL2014
$image | New-SqlClone -Name 'AdventureWorks-clone1' -Location $sqlServerInstance | Wait-SqlCloneOperation`}
                </pre>
            </div>
        );
    }
});

const mapDispatchToProps = (dispatch) => {
    return {
        alignMode: () => {
            dispatch(changeToSettingMode());
        }
    };
};

export default connect(null, mapDispatchToProps)(PowerShellPage);



// WEBPACK FOOTER //
// ./src/components/settings/PowerShellPage/index.jsx